export enum EServiceName {
  AGENTS = 'agents',
  WIDGETS = 'widgets',
  API = 'api',
  SPEECH = 'speech'
}

export interface IApiKey {
  providerName?: string;
  serviceName: EServiceName;
  encryptedKey?: string;
  id: string;
}

export interface IApiKeyCreate {
  providerName?: string;
  serviceName: EServiceName;
  encryptedKey?: string;
}
